import { SkeletonView } from '@/design-system/components/cards/SkeletonView';
import { SxProp, View } from 'dripsy';
import React from 'react';

export const FormSkeleton = () => (
  <View sx={styles.container}>
    <View sx={styles.containerTop}>
      <View>
        <SkeletonView shape="circle" />
      </View>
      <View sx={styles.asset}>
        <SkeletonView height={19} width={180} sx={styles.textTitle} />
        <SkeletonView />
      </View>
    </View>
    <View sx={styles.containerBottom}>
      <SkeletonView height={19} width={150} sx={styles.textTitle} />
      <SkeletonView sx={styles.textTitle} />
      <SkeletonView width={170} sx={styles.textTitle} />
    </View>
  </View>
);

enum StyleName {
  container = 'container',
  containerTop = 'containerTop',
  containerBottom = 'containerBottom',
  asset = 'asset',
  textTitle = 'textTitle'
}

const styles: Record<StyleName, SxProp> = {
  container: { paddingX: '$5', paddingY: '$5' },
  containerTop: { mb: '$5', flexDirection: 'row', alignItems: 'center' },
  containerBottom: { mb: '$2' },
  asset: { ml: '$2' },
  textTitle: { mb: '$1' }
};
